import { labsGameUrl, labsHomeUrl } from '../labs/labsNav'
import { LabsGame } from './Brand'

// Cross-game switcher shown in free-play contexts (reveal / summary / mode-choice): one compact row
// of the two OTHER games + "Other games" (→ /labs home). This is how we seed the other games from
// existing traffic, and the "Other games" tile doubles as the escape back to the labs landing.
const GAMES: { key: LabsGame; slug: string; label: string }[] = [
  { key: 'twentyfour', slug: '24', label: '24-game' },
  { key: 'rebus', slug: 'rebus', label: 'Rebus' },
  { key: 'cryptic', slug: 'cryptic', label: 'Cryptic' },
]

const tile =
  'rounded-lg border border-gray-200 py-2 text-xs font-semibold text-gray-700 transition-colors hover:border-[#820458] hover:bg-[#820458]/5'

export const OtherGamesLinks = ({ current }: { current: LabsGame }) => {
  const others = GAMES.filter((g) => g.key !== current)
  return (
    <div className="mt-3 grid grid-cols-3 gap-2">
      {others.map((g) => (
        <a key={g.slug} href={labsGameUrl(g.slug)} className={tile}>
          {g.label}
        </a>
      ))}
      <a href={labsHomeUrl()} className={tile}>
        Other games
      </a>
    </div>
  )
}
